import React, { useState } from "react";
import DeselectableRadioGroup from "../../../../../blocks/FormItems/DeselectableRadioGroup";
import { foodPreferenceOptions } from "../../../Options/historyOptions";
import { Form, Input } from "antd";

const FoodPreferences = ({ form }) => {
  const [refresh, setRefresh] = useState(false);
  const showOthers = form.getFieldValue("food_preferences") === "others";
  return (
    <>
      <DeselectableRadioGroup
        label={"Food Preferences"}
        name={"food_preferences"}
        options={foodPreferenceOptions}
        form={form}
        setRefresh={setRefresh}
      />
      {showOthers && (
        <Form.Item name={"food_preferences_others"}>
          <Input.TextArea rows={2} style={{ maxWidth: 1200 }} />
        </Form.Item>
      )}
    </>
  );
};

export default FoodPreferences;
